// extracted by mini-css-extract-plugin
module.exports = {"container":"_19XYUx7bF7jKXJf_GsHU75","cancelBtn":"zFsYRJSQ1UIYDx9BCvNS7","icon":"_1lTjbmEM1CRxQRAbufjpqm","saveBtn":"_1LCzvB-L4eBmlPT7gxVRlU"};